// Datetime presentation helpers (feature F-E Phase 4; first date util in repo).
//
// Wire format is ISO-8601 UTC (conventions.md); the UI presents HKT
// (Asia/Hong_Kong). No date library — `Intl.DateTimeFormat` + `formatToParts`
// gives a deterministic "YYYY-MM-DD HH:MM:SS" regardless of locale ordering.

const _parts = (iso: string, timeZone: string): Record<string, string> =>
  Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
      .formatToParts(new Date(iso))
      .map((p) => [p.type, p.value]),
  );

function _format(iso: string, timeZone: string): string {
  const p = _parts(iso, timeZone);
  return `${p.year}-${p.month}-${p.day} ${p.hour}:${p.minute}:${p.second}`;
}

/** ISO-8601 UTC → "YYYY-MM-DD HH:MM:SS" in Hong Kong time. */
export function formatHkt(iso: string): string {
  return _format(iso, "Asia/Hong_Kong");
}

/** ISO-8601 UTC → "YYYY-MM-DD HH:MM:SS" in UTC (drawer secondary line). */
export function formatUtc(iso: string): string {
  return _format(iso, "UTC");
}

// HKT is a fixed +08:00 offset (no DST), so a date-picker value (HKT calendar
// day) maps to a UTC instant deterministically. Used to convert the audit
// filter date pickers to the UTC range the API expects.

/** HKT calendar day "YYYY-MM-DD" → ISO-8601 UTC at 00:00:00 HKT. */
export function hktDayStartUtc(day: string): string {
  return new Date(`${day}T00:00:00+08:00`).toISOString();
}

/** HKT calendar day "YYYY-MM-DD" → ISO-8601 UTC at 23:59:59.999 HKT (inclusive end). */
export function hktDayEndUtc(day: string): string {
  return new Date(`${day}T23:59:59.999+08:00`).toISOString();
}
